export default {"src":"/_next/static/media/backCard.c7d4db94.svg","height":318,"width":490,"blurWidth":0,"blurHeight":0};